<template>
  <a-form-model ref="form" :model="form.data" :rules="form.rules">
    <a-form-model-item label="状态" prop="status">
      <dict-select v-model="form.data.status" dict-code="INVITATION_STATUS"/>
    </a-form-model-item>
    <a-form-model-item label="失败原因" prop="reason" v-if="form.data.status === 'FAILED' ">
      <div class="a-input">
        <a-input v-model="form.data.reason"></a-input>
      </div>
    </a-form-model-item>
<!--    <a-form-model-item label="视频封面" prop="coverPath" v-if="form.data.type === 'VIDEO'">-->
<!--      <div class="a-input">-->
<!--        <simple-uploader v-model="form.data.coverPath" />-->
<!--      </div>-->
<!--    </a-form-model-item>-->
    <a-form-model-item>
      <a-space>
        <a-button type="primary" v-if="!invitationId" @click="onAdd">创建</a-button>
        <a-button type="primary" v-if="invitationId" @click="onUpdate">更新</a-button>
        <a-button @click="onCancel">{{ $t('CANCEL') || '取消' }}</a-button>
      </a-space>
    </a-form-model-item>
  </a-form-model>
</template>

<script>
import {
  _queryInvitation,
  _updateInvitation,
} from '@/api/invitationApi';
import DictSelect from '../../../components/DictSelect.vue';

async function getInvitation() {
  const result = await _queryInvitation(this.invitationId);
  if (result) {
    this.form.data.status = result.status;
    this.form.data.reason = result.reason;
  }
}

async function onUpdate() {
  this.$refs.form.validate(async (valid) => {
    if (valid) {
      const result = await _updateInvitation(this.invitationId, {
        status: this.form.data.status,
        reason: this.form.data.reason,
        // subName: this.form.data.subName,
      });
      if (result) {
        if (this.onSubmitHandler) {
          this.$message.success('更新成功');
          this.onSubmitHandler();
        }
      }
    }
  });
}
// async function onUpdateInvitation() {
//   this.$refs.form.validate(async (valid) => {
//     if (valid) {
//       const result = await _updateInvitation(this.invitationId, {
//         status: this.form.data.status,
//         reason: this.form.data.reason,
//         // subName: this.form.data.subName,
//       });
//       if (result) {
//         if (this.onSubmitHandler) {
//           this.$message.success('审核成功');
//           this.onSubmitHandler();
//         }
//       }
//     }
//   });
// }

function onCancel() {
  if (this.onCancelHandler) {
    this.onCancelHandler();
  }
}

export default {
  name: 'InvitationEdit',
  components: { DictSelect, },
  props: {
    invitationId: String,
    onSubmitHandler: Function,
    onCancelHandler: Function,
  },
  watch: {
    invitationId() {
      if (this.invitationId) {
        this.getInvitation();
      }
    },
  },
  methods: {
    // onAdd,
    onUpdate,
    onCancel,
    getInvitation,
    // onUpdateInvitation,
  },
  data() {
    return {
      form: {
        data: {
          status: '',
          // coverPath: '',
          reason: '',

        },
        rules: {
          status: [{ required: true, trigger: 'blur' }],
          reason: [{ required: true, trigger: 'blur' }],
          // reason: [{ required: true, trigger: 'blur' }],
        },
        title: '',
      },
    };
  },
  created() {
    if (this.invitationId) {
      this.getInvitation();
    }
  },
};
</script>
